import React from 'react';
import { string } from 'prop-types';
import snarkdown from 'snarkdown';
import DOMPurify from 'isomorphic-dompurify';
const ALLOWED_TAGS = ['p', 'strong', 'b', 'em', 'i', 'ul', 'ol', 'li', 'dl', 'dt', 'dd', 'br'];
export const MarkDownSection = _ref => {
  let {
    markDown
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    // eslint-disable-next-line react/no-danger
    dangerouslySetInnerHTML: {
      __html: DOMPurify.sanitize(snarkdown(markDown), {
        ALLOWED_TAGS
      })
    }
  });
};
MarkDownSection.propTypes = {
  markDown: string.isRequired
};
MarkDownSection.defaultProps = {};